import Vue from 'vue'
import App from './App.vue'
import store from './store/store.js'
import router from './router'
import 'reset-css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import vueSmoothScroll from 'vue2-smooth-scroll'
import mixins from './mixins/globalFunctions'
import _ from 'lodash'

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)

Vue.use(vueSmoothScroll, {
  updateHistory: false,
  duration: 800
})

Vue.mixin(mixins)

// lodashの登録
Vue.prototype.$_ = _

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
